module.exports = "<div class=\"user\"\n    *ngIf=\"mailbox\">\n    <div class=\"user__info\">\n        <p class=\"user__name\">{{mailbox.name}}</p>\n        <p class=\"user__email\">({{mailbox.email}})</p>\n    </div>\n    <img class=\"user__photo\" src=\"{{mailbox.photo}}\" alt=\"\">\n    <button class=\"user__exit-btn\" (click)=\"onExit()\"></button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/mailbox/menu/user-thumb/user-thumb.component.html
// module id = 622
// module chunks = 1